/*
  An npm JavaScript library for front end web apps. Implements a minimal
  Bitcoin Cash wallet.
*/
var RetryQueue = require('./lib/retry-queue.js'); // export default RetryQueue


module.exports = RetryQueue;